/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Default_NameInputs */

const en_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Group`)
};

const fr_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe de traduction`)
};

const de_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsgruppe`)
};

const it_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di traduzione`)
};

const ru_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа переводов`)
};

const es_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de traducción`)
};

const zh_cn2_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译组`)
};

const ja_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳グループ`)
};

const hi_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद समूह`)
};

const pt_pt2_translation_merge_default_name = /** @type {(inputs: Translation_Merge_Default_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Tradução`)
};

/**
* | output |
* | --- |
* | "Translation Group" |
*
* @param {Translation_Merge_Default_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_default_name = /** @type {((inputs?: Translation_Merge_Default_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Default_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_default_name(inputs)
	if (locale === "de") return de_translation_merge_default_name(inputs)
	if (locale === "it") return it_translation_merge_default_name(inputs)
	if (locale === "ru") return ru_translation_merge_default_name(inputs)
	if (locale === "es") return es_translation_merge_default_name(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_default_name(inputs)
	if (locale === "ja") return ja_translation_merge_default_name(inputs)
	if (locale === "hi") return hi_translation_merge_default_name(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_default_name(inputs)
	return en_translation_merge_default_name(inputs)
});